var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-bg-grey",attrs:{"id":"app"}},[_c('symbols-svg'),_c('transition',{attrs:{"name":"t-fader"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }